export const lotStates = {
  CREATED: 'Creado',
  PENDING_PICKING: 'Pendiente de picking',
  CANCELLED: 'cancelado',
  DELIVERED: 'entregado'
}
